/**
 * 固定文と数字入りの定型文は、LLMに投げずその場で英語にする（T3/T4）。
 *
 * 背景（2026-10-04 本番調査）: 「取得 ¥189,950」→"Received ¥…"、
 * 「{n}件の図番」→"Drawing No. 8"、「もっと見る（残り12件）」→null、
 * 「三木 和美 を削除」→"Remove Tanimura Mami"（別人の名前）など、
 * 数字や名前が入る文を毎回モデルに訳させていたため壊れていた。
 * ここで決め打ちにすると、訳が安定し、初回表示も速くなる（LLM呼び出しゼロ）。
 *
 * 値（人名・会社名・品名など）は $1 としてそのまま残すので、
 * 名前が別人に書き換わることが原理的に起きない。
 */

// 1,234 の桁区切りと yyyy/mm/dd はそのまま通す（EN表示でも同じ書式）
const NUM = '([\\d,]+(?:\\.\\d+)?)';

export const STATIC_PATTERNS = [
  // ── 金額・件数の定型文 ──
  [new RegExp(`^取得\\s*¥${NUM}$`), 'Acquired ¥$1'],
  [new RegExp(`^簿価\\s*¥${NUM}$`), 'Book value ¥$1'],
  [new RegExp(`^今月\\s*¥${NUM}$`), 'This month ¥$1'],
  [new RegExp(`^${NUM}件の図番$`), '$1 drawing numbers'],
  [new RegExp(`^${NUM}\\s*式$`), '$1 set'],
  [new RegExp(`^${NUM}\\s*台$`), '$1 units'],
  [new RegExp(`^${NUM}\\s*個$`), '$1 pcs'],
  [new RegExp(`^${NUM}\\s*本$`), '$1 pcs'],
  [new RegExp(`^${NUM}\\s*枚$`), '$1 sheets'],
  [new RegExp(`^${NUM}\\s*件$`), '$1 items'],
  [new RegExp(`^もっと見る（残り\\s*${NUM}\\s*件）$`), 'Show more ($1 left)'],
  [new RegExp(`^要対応\\s*${NUM}\\s*件うちブロック中\\s*${NUM}\\s*件$`),
    '$1 need action, $2 blocked'],
  [new RegExp(`^${NUM}\\s*/\\s*${NUM}\\s*有効$`), '$1 / $2 active'],
  [new RegExp(`^${NUM}\\s*/\\s*${NUM}\\s*使用中$`), '$1 / $2 in use'],

  // ── 値をそのまま残す定型文（T2の事故防止）──
  [/^(.+?)\s*を削除$/, 'Remove $1'],
  [/^(.+?)\s*を復元$/, 'Restore $1'],
  [/^期限\s*(.+)$/, 'Due $1'],
  [/^期間:\s*(.+?)\s*[～~]\s*(.+)$/, 'Period: $1 – $2'],
  [/^用途:\s*(.+)$/, 'Purpose: $1'],
  [/^使用者:\s*(.+)$/, 'User: $1'],
  [/^端末:\s*(.+)$/, 'Device: $1'],
  [/^(.+?)\s*—\s*自動解放されません$/, '$1 — not auto-released'],
  [/^最終確認:\s*(.+?)\s*—\s*資産に紐付いているため自動解放されません$/,
    'Last checked $1 — linked to an asset, not auto-released'],
  [/^最終確認:\s*(.+)$/, 'Last checked $1'],
  [/^(.+?)\s*を選択$/, 'Select $1'],
  [/^(.+?)\s*を編集$/, 'Edit $1'],

  // ── 製造（T4: 部署名に書き換えない）──
  [/^製造オーダーNo\.?$/, 'Work Order No.'],
  [/^製造オーダー$/, 'Work Orders'],
  [/^製造中$/, 'In production'],
  [/^製造管理$/, 'Production Management'],
  [/^製造$/, 'Production'],
  [/^センスビー製造部$/, 'Sensbey Production'],

  // ── 状態チップ（画面ごとに違う訳になっていたので1か所に固定）──
  [/^未着手$/, 'Not started'],
  [/^進行中$/, 'In progress'],
  [/^完了$/, 'Done'],
  [/^保留$/, 'On hold'],
  [/^ブロック$/, 'Blocked'],
  [/^ブロック中$/, 'Blocked'],
  [/^中止$/, 'Cancelled'],

  // ── 曜日（1文字のときだけ）──
  [/^月$/, 'Mon'], [/^火$/, 'Tue'], [/^水$/, 'Wed'], [/^木$/, 'Thu'],
  [/^金$/, 'Fri'], [/^土$/, 'Sat'], [/^日$/, 'Sun'],

  // ── null が返っていた短い語 ──
  [/^回答する$/, 'Answer'],
  [/^回答$/, 'Answer'],
];

/** 決め打ちで英語にできるなら返す。できなければ null。 */
export function staticTranslate(text) {
  const s = String(text || '').trim();
  if (!s) return null;
  for (const [re, out] of STATIC_PATTERNS) {
    const m = s.match(re);
    if (m) return out.replace(/\$(\d)/g, (_, i) => (m[Number(i)] ?? '').trim());
  }
  return null;
}
